<template>
  <div role="group">
    <div class="filter-row">
      <Input
        id="dateFrom"
        :label="$t('field.dateFrom')"
        type="date"
        v-model="$v.form.dateFrom.$model"
        :error="$v.form.dateFrom.$dirty && $v.form.dateFrom.$error ? $t('validation.fieldWarningRequired') : ''"
        :required="true"
        aria-describedby="filter-form-dateFrom"
        autofocus
      />
      <Input
        id="dateTo"
        :label="$t('field.dateTo')"
        type="date"
        v-model="$v.form.dateTo.$model"
        :error="$v.form.dateTo.$dirty && $v.form.dateTo.$error ? $t('validation.fieldWarningRequired') : ''"
        :required="true"
        aria-describedby="filter-form-dateTo"
        autofocus
      />
      <Dropdown
        v-model="period"
        :label="$t('field.period')"
        :options="periodOptions"
        :placeholder="$t('system.placeholder.chooseOption')"
        @input="setPeriodDates"
      />
    </div>
  </div>
</template>

<script>
import Utils from "@/utils/utils";
import Dropdown from "@/components/forms/Dropdown.vue";
import { required } from 'vuelidate/lib/validators';
import Input from "@/components/forms/Input.vue";

export default {
  name: 'date-search-table',
  components: {Input, Dropdown: Dropdown},
  data() {
    return {
      isOpen: true,
      form: {
        dateFrom: Utils.getStartOfMonth(),
        dateTo: Utils.getEndOfMonth(),
      },
      period: 'actualMonth',
      fullLocale: this.$i18n.locale,
      dateFormatOptions: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      },
    };
  },
  validations: {
    form: {
      dateFrom: { required },
      dateTo: { required }
    }
  },
  props: {
    callback: {
      Type: Function
    },
    useFutureFilters: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      if(newVal !== oldVal)
      {
        this.fullLocale = this.$i18n.locale;
      }
    }
  },
  computed: {
    periodOptions() {
      const opts = [
        { value: 'actualMonth', label: this.$t('filter.actualMonth') },
        { value: 'previousMonth', label: this.$t('filter.previousMonth') },
      ];
      if (this.useFutureFilters) {
        opts.push({ value: 'nextMonth', label: this.$t('filter.nextMonth') });
      }
      opts.push(
        { value: 'actualYear', label: this.$t('filter.actualYear') },
        { value: 'previousYear', label: this.$t('filter.previousYear') }
      );
      if (this.useFutureFilters) {
        opts.push({ value: 'nextYear', label: this.$t('filter.nextYear') });
      }
      return opts;
    }
  },
  methods: {
    setPeriodDates() {
      if (this.period === 'previousMonth') {
        this.form.dateFrom = Utils.getStartOfPreviousMonth();
        this.form.dateTo = Utils.getEndOfPreviousMonth();
      } else if (this.period === 'actualMonth') {
        this.form.dateFrom = Utils.getStartOfMonth();
        this.form.dateTo = Utils.getEndOfMonth();
      } else if (this.period === 'nextMonth') {
        this.form.dateFrom = Utils.getStartOfNextMonth();
        this.form.dateTo = Utils.getEndOfNextMonth();
      } else if (this.period === 'previousYear') {
        this.form.dateFrom = Utils.getStartOfPreviousYear();
        this.form.dateTo = Utils.getEndOfPreviousYear();
      } else if (this.period === 'actualYear') {
        this.form.dateFrom = Utils.getStartOfYear();
        this.form.dateTo = Utils.getEndOfYear();
      } else if (this.period === 'nextYear') {
        this.form.dateFrom = Utils.getStartOfNextYear();
        this.form.dateTo = Utils.getEndOfNextYear();
      }
    },
    search() {
      this.callback(this.form.dateFrom, this.form.dateTo);
    }
  }
};
</script>

<style scoped>

.filter-row {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
}
.filter-row > * {
  flex: 1 1 0;
  min-width: 180px;
}
</style>
